import { render, staticRenderFns } from "./BackendProfilesTable.vue?vue&type=template&id=1f1c9139&scoped=true&"
import script from "./BackendProfilesTable.vue?vue&type=script&lang=js&"
export * from "./BackendProfilesTable.vue?vue&type=script&lang=js&"
import style0 from "./BackendProfilesTable.vue?vue&type=style&index=0&id=1f1c9139&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c9139",
  null
  
)

export default component.exports